const state = {
    workorderHistoryContainerDataFields: [
        {
            key: "pkg_wko_code",
            label: "包裝單號",
            sortable: true,
        },
        {
            key: "license_plate",
            label: "車牌",
            sortable: true,
        },
        {
            key: "container_no",
            label: "櫃號",
            sortable: true,
        },
        {
            key: "total_weight",
            label: "總重",
            sortable: true,
        },
        {
            key: "total_plno",
            label: "棧板數",
            sortable: true,
        },
        {
            key: "start_time",
            label: "開始時間",
            sortable: true,
        },
        {
            key: "end_time",
            label: "結束時間",
            sortable: true,
        }
    ],
    workorderHistoryContainerDataItem: [],
    rowClickData: {},
    workorderHistoryTableStyle: "",
}
const getters = {
    get_workorderHistoryContainerDataFields: state => {
        return state.workorderHistoryContainerDataFields
    },
    get_workorderHistoryContainerDataItem: state => {
        return state.workorderHistoryContainerDataItem
    },
    get_rowClickData: state => {
        return state.rowClickData
    },
    get_workorderHistoryTableStyle: state => {
        return state.workorderHistoryTableStyle
    },
}
const actions = {
    set_workorderHistoryContainerDataFields(context, array) {
        context.commit('SET_WORKORDERHISTORYCONTAINERDATAFIELDS', array);
    },
    set_workorderHistoryContainerDataItem(context, array) {
        context.commit('SET_WORKORDERHISTORYCONTAINERDATAITEM', array);
    },
    set_rowClickData(context, obj) {
        context.commit('SET_ROWCLICKDATA', obj);
    },
    clear_workorderHistoryContainerDataItem(context) {
        context.commit('CLEAR_WORKORDERHISTORYCONTAINERDATAITEM');
    },
    clear_rowClickData(context) {
        context.commit('CLEAR_ROWCLICKDATA');
    },
    set_workorderHistoryTableStyle(context, string = '') {
        context.commit('SET_WORKORDERHISTORYTABLESTYLE', string);
    },
}
const mutations = {
    SET_WORKORDERHISTORYCONTAINERDATAFIELDS(state, array) {
        state.workorderHistoryContainerDataFields = array;
    },
    SET_WORKORDERHISTORYCONTAINERDATAITEM(state, array) {
        state.workorderHistoryContainerDataItem = array;
    },
    SET_ROWCLICKDATA(state, obj) {
        state.rowClickData = obj;
    },
    CLEAR_WORKORDERHISTORYCONTAINERDATAITEM(state) {
        state.workorderHistoryContainerDataItem = [];
    },
    CLEAR_ROWCLICKDATA(state) {
        state.rowClickData = {};
    },
    SET_WORKORDERHISTORYTABLESTYLE(state, string) {
        state.workorderHistoryTableStyle = string;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workorderHistoryContainerData.js